import { Feature } from '@ts-core/utils/features';

import DashboardPage from 'modules/dashboard/pages/DashboardPage';
import GroupDetailsPage from 'modules/groups/pages/GroupDetailsPage';

import StudentsPage from 'modules/students/pages/StudentsPage';
import StudentDetailsPage from 'modules/students/pages/StudentDetailsPage';
import StudentAssignmentResultPage from 'modules/assignments/pages/StudentAssignmentResultPage';
import StudentCoursePracticeSessionResultsPage from 'modules/practice/pages/StudentPracticeSessionResultsPage';

import SubjectPage from 'modules/subjects/pages/SubjectPage';

import ExerciseEntryPage from 'modules/exercises/pages/ExerciseEntryPage';
import ExercisePreviewEntryPage from 'modules/exercises/pages/ExercisePreviewEntryPage';

import AssignmentsListPage from 'modules/assignments/pages/AssignmentsListPage';
import EditAssignmentPage from 'modules/assignments/pages/EditAssignmentPage';
import NewAssignmentPage from 'modules/assignments/pages/NewAssignmentPage';
import AssignmentDetailsPage from 'modules/assignments/pages/AssignmentDetailsPage';

import MediaPlayerPage from 'modules/media/pages/MediaPlayerPage';

import RankingsPage from 'modules/rankings/pages/RankingsPage';

import ProfessorsPage from 'modules/courses/pages/professors/ProfessorsPage';

import CourseStatsPage from 'modules/courses/pages/CourseStatsPage';
import SubjectStatsPage from 'modules/subjects/pages/SubjectStatsPage';

import MessagesPage from 'modules/messages/pages/messages/MessagesPage';

import CourseMediaStatsPage from 'modules/media/pages/CourseMediaStatsPage';
import MediaItemStatsPage from 'modules/media/pages/MediaItemStatsPage';

import StudentMediaItemStatsPage from 'modules/media/pages/StudentMediaItemStatsPage';

import AttendancePage from 'modules/attendance/pages/AttendancePage';

import ThreadsPage from '@ts-core/pages/Forum/ThreadsPage';
import ThreadDetailsPage from '@ts-core/pages/Forum/ThreadDetailsPage';
import EditThreadPage from '@ts-core/pages/Forum/EditThreadPage';
import NewThreadPage from '@ts-core/pages/Forum/NewThreadPage';
import EditThreadAnswerPage from '@ts-core/pages/Forum/EditThreadAnswerPage';

import ActivitiesPage from '../activities/pages/ActivitiesPage';
import CreateActivityPage from '../activities/pages/CreateActivityPage';
import EditActivityPage from '../activities/pages/EditActivityPage';
import ActivityDetailsPage from '../activities/pages/ActivityDetailsPage';
import ActivityAnswerPage from '../activities/pages/ActivityAnswerPage';

export default [
  {
    component: DashboardPage,
    path: '/dashboard',
  },

  {
    component: NewAssignmentPage,
    path: '/assignments/new',
  },
  {
    component: AssignmentDetailsPage,
    path: '/assignments/:assignmentId/details/:tab',
  },
  {
    component: EditAssignmentPage,
    path: '/assignments/:assignmentId/edit',
  },
  {
    component: AssignmentsListPage,
    path: '/assignments',
  },

  {
    component: MediaPlayerPage,
    path: '/subjects/:subjectId/media/:mediaItemId/player',
    requiredFeatures: [Feature.VideoOnDemand],
  },
  {
    component: ExerciseEntryPage,
    path: '/subjects/:subjectId/exercises/exercise/:type/:exerciseId?',
  },
  {
    component: ExercisePreviewEntryPage,
    path: '/subjects/:subjectId/exercise-view/:type/:exerciseId',
  },
  {
    component: SubjectPage,
    path: '/subjects/:subjectId/:tab',
  },

  {
    component: RankingsPage,
    path: '/rankings/:rankingType(general|assignments|subjects)',
    requiredFeatures: [Feature.Ranking],
  },

  {
    component: StudentAssignmentResultPage,
    path: '/students/:studentId/assignments/:assignmentId',
  },
  {
    component: StudentCoursePracticeSessionResultsPage,
    path: '/students/:studentId/practice/:practiceSessionId',
  },

  {
    component: StudentMediaItemStatsPage,
    path: '/students/:studentId/media-stats/:mediaId',
    requiredFeatures: [Feature.VideoOnDemand],
  },

  {
    component: StudentDetailsPage,
    path: '/students/:studentId/:tab',
  },
  {
    component: StudentsPage,
    path: '/students',
  },

  {
    component: GroupDetailsPage,
    path: '/groups/:groupId',
  },

  {
    component: ProfessorsPage,
    path: '/professors',
  },

  {
    component: SubjectStatsPage,
    path: '/stats/subjects/:subjectId',
  },
  {
    component: CourseStatsPage,
    path: '/stats',
    exact: true,
  },

  {
    component: MessagesPage,
    path: '/messages',
  },

  {
    component: MediaItemStatsPage,
    path: '/media-stats/:subjectId/:mediaId',
    requiredFeatures: [Feature.VideoOnDemand],
  },
  {
    component: CourseMediaStatsPage,
    path: '/media-stats',
    requiredFeatures: [Feature.VideoOnDemand],
  },

  {
    component: AttendancePage,
    path: '/attendance/:tab',
  },

  {
    component: NewThreadPage,
    path: '/forum/new-thread',
    requiredFeatures: [Feature.Forum],
  },
  {
    component: EditThreadPage,
    path: '/forum/:threadId/edit',
    requiredFeatures: [Feature.Forum],
  },
  {
    component: EditThreadAnswerPage,
    path: '/forum/:threadId/answers/:answerId/edit',
    requiredFeatures: [Feature.Forum],
  },
  {
    component: ThreadDetailsPage,
    path: '/forum/:threadId',
    requiredFeatures: [Feature.Forum],
  },
  {
    component: ThreadsPage,
    path: '/forum',
    requiredFeatures: [Feature.Forum],
  },

  {
    component: CreateActivityPage,
    path: '/activities/create',
    requiredFeatures: [Feature.Activities],
  },
  {
    component: EditActivityPage,
    path: '/activities/:activityId/edit',
    requiredFeatures: [Feature.Activities],
  },
  {
    component: ActivityAnswerPage,
    path: '/activities/:activityId/answers/:answerId',
    requiredFeatures: [Feature.Activities],
  },
  {
    component: ActivityDetailsPage,
    path: '/activities/:activityId/details/:tab',
    requiredFeatures: [Feature.Activities],
  },
  {
    component: ActivitiesPage,
    path: '/activities',
    exact: true,
    requiredFeatures: [Feature.Activities],
  },
];
